import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@rockwell-automation-inc/service';
import { delay, filter, take, tap } from 'rxjs';

@Component({
  selector: 'px-callback',
  templateUrl: './callback.component.html',
})
export class CallbackComponent { 
  constructor(
  public auth: AuthService,
  public router: Router,
) { }

navigate$ = this.auth.isAuthenticated$.pipe(
  tap(isAuthenticated => {
    if (!isAuthenticated) {
      this.auth.logout();
      this.auth.login()
      return;
    }
    this.router.navigate(['/dashboard/callback']);
  }))
}
